import './CPFilterPopupOrders.scss';

import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import FilterRange from '../../GenericComponents/FilterRange';

const CPFilterPopupOrders = ({ filterFields, onFilterSubmit, onSetIsReset }) => {
  const statusOptions = [
    { value: '', label: 'ALL' }
  ];

  if(filterFields?.Statuses?.length > 0) {
    filterFields.Statuses.map((item)=> {
      const status = {
        value: item,
        label: item
      }
      statusOptions.push(status)
    }) 
  }

  const MINRANGE = Number(filterFields?.['Min total'].value);
  const MAXRANGE = Number(filterFields?.['Max total'].value);
  const FILTER_DEFAULT_DATE_RANGE = filterFields?.['Filter default date range'].value;
  const MILLISECOND_PER_DAY = 86400000;
  const initialStateDateFilter = [new Date(new Date().valueOf() - FILTER_DEFAULT_DATE_RANGE * MILLISECOND_PER_DAY), new Date()];
  const [dateFilter, setDateFilter] = useState(initialStateDateFilter);
  const [isShowFilterPopup, setShowFilterPopup] = useState(false);
  const [statusSelected, setStatusSelected] = useState(statusOptions[0]);
  const [rangeData, setRangeData] = useState([MINRANGE, MAXRANGE]);
  const [isClearFilter, setIsClearFilter] = useState(false);

  const onChangeRange = (rangeValue) => {
    setRangeData(rangeValue);
  };

  const onSelect = (item) => {
    setStatusSelected(item);
  };

  const onHandleReset = () => {
    setDateFilter(initialStateDateFilter);

    setIsClearFilter(true);

    onSetIsReset(true)

    setStatusSelected(statusOptions[0]);
  };

  const onHandleApply = (evt) => {
    onFilterSubmit(evt, dateFilter, rangeData, statusSelected)

    setShowFilterPopup(false);
  };

  return (
    filterFields && (
      <div className='cp-page-header__btn'>
        <span className='cp-icon cp-icon--filter' onClick={() => setShowFilterPopup(!isShowFilterPopup)}></span>
        <div className={`cp-filter-popup-orders ${isShowFilterPopup ? 'show' : ''}`}>
          <form>
            <div className='cp-filter-popup-orders__wrap'>
              <div className='cp-filter-popup-orders__item filter-date'>
                <Text tag='span' className='cp-filter-popup-orders__item__label' field={filterFields['Date']} />
                <div className='cp-filter-popup-orders__item__value'>
                  <DateRangePicker
                    selected={dateFilter}
                    onChange={(date) => setDateFilter(date)}
                    format='dd MMM yyyy'
                    dayPlaceholder='dd'
                    monthPlaceholder='mm'
                    yearPlaceholder='yyyy'
                    value={dateFilter}
                    clearIcon={null}
                  />
                </div>
              </div>
              <div className={`cp-filter-popup-orders__item filter-range`}>
                <Text tag='span' className='cp-filter-popup-orders__item__label' field={filterFields['Total order']} />
                <div className='cp-filter-popup-orders__item__value'>
                  <FilterRange onChangeRange={onChangeRange} minRange={MINRANGE} maxRange={MAXRANGE} isClearFilter={isClearFilter} />
                </div>
              </div>
              <div className='cp-filter-popup-orders__item'>
                <Text tag='span' className='cp-filter-popup-orders__item__label' field={filterFields['Status']} />
                <div className='cp-filter-popup-orders__item__value'>
                  <Select
                    id='status-select'
                    onChange={(data) => onSelect(data)}
                    value={statusSelected}
                    options={statusOptions}
                    className='cp-select'
                    classNamePrefix='cp-select'
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>
            <div className='cp-filter-popup-orders__btn'>
              <button type='button' className='cp-filter-popup-orders__btn__item btn btn-outline-primary' onClick={() => onHandleReset()}>
                <Text field={filterFields?.Reset} />
              </button>
              <button type='submit' className='cp-filter-popup-orders__btn__item btn btn-primary' onClick={onHandleApply}>
                <Text field={filterFields?.Apply} />
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

CPFilterPopupOrders.propTypes = {
  filterFields: PropTypes.any,
  onFilterSubmit: PropTypes.any,
  onSetIsReset: PropTypes.any
};

export default CPFilterPopupOrders;